import { render, staticRenderFns } from "./dailyreportstatistic.vue?vue&type=template&id=e2418b8a&scoped=true&"
import script from "./dailyreportstatistic.vue?vue&type=script&lang=js&"
export * from "./dailyreportstatistic.vue?vue&type=script&lang=js&"
import style0 from "./dailyreportstatistic.vue?vue&type=style&index=0&id=e2418b8a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2418b8a",
  null
  
)

export default component.exports